import type { SVGProps } from 'react';
const SvgNearMeDisabled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#near_me_disabled_svg__a)">
      <path
        fill="currentColor"
        d="M12 6.34 21 3l-3.34 9L12 6.34Zm10.61 13.44L4.22 1.39 2.81 2.81l5.07 5.07L3 9.69v1.41l7.07 2.83L12.9 21h1.41l1.81-4.88 5.07 5.07 1.42-1.41Z"
      />
    </g>
    <defs>
      <clipPath id="near_me_disabled_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNearMeDisabled;
